var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/magic-star"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/magic-star_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "magic-star"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8656 7.72351L13.8186 9.69633C13.5375 9.9668 13.3466 10.5078 13.4049 10.8949L13.7231 13.2071C13.9299 14.6868 13.0125 15.3285 11.6866 14.639L9.43806 13.4617C9.06152 13.2655 8.44634 13.2761 8.08042 13.4935L6.11288 14.6443C4.55901 15.5512 3.63093 14.8671 4.04459 13.117L4.62264 10.6721C4.7287 10.2267 4.53249 9.61679 4.19838 9.3145L2.33694 7.63337C1.00581 6.42953 1.37704 5.33704 3.16955 5.19915L5.43936 5.02944C5.86362 4.99762 6.37803 4.66351 6.57426 4.28698L7.75162 2.0384C8.44635 0.717877 9.56534 0.72318 10.2389 2.05431L11.2889 4.13321C11.4692 4.48323 11.9253 4.82262 12.3124 4.88096L15.1232 5.33705C16.64 5.581 16.974 6.65755 15.8656 7.72351Z",
    fill: "#00C851"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1582391789b8e44be6ca3e4592c780de.svg";
export { ForwardRef as ReactComponent };